
const isString = (target: any): boolean => {
    return Object.prototype.toString.call(target) === '[object String]'
}

const isArray = (target: any): boolean => {
    return Object.prototype.toString.call(target) === '[object Array]'
}

const isObject = (target: any): boolean => {
    return Object.prototype.toString.call(target) == '[object Object]'
}

const isError = (target: any): target is Error => {
    return Object.prototype.toString.call(target) == '[object Error]'
}

const isUndefined = (target: any): target is undefined => target === void 0

// 是否有效的数组， 数组 + 不为空
const effectiveArray = <T = any>(target: any): target is T[] => {
    return isArray(target) && target.length !== 0
}

// 是否有效的对象， 对象 + 不为空
const effectiveObject = (target: any): boolean => {
    return isObject(target) && Object.keys(target).length !== 0
}

// 是否有效的字符串
const effectiveString = (target: any): target is string => {
    return isString(target) && target !== ''
} 


// 是否为有效url
const effectiveUrl = (url: string): boolean => {
    const STR_REGEX = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    return STR_REGEX.test(url)
}

const isJSON = (str) => {
    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            return typeof obj == 'object' && obj;
        } catch(e) {
            return false;
        }
    }
}

// 判断ie浏览器
const isIE = () => {
	if(!!(window as any).ActiveXObject || "ActiveXObject" in window)
		return true;
	else
		return false;
}


export {
    effectiveArray,
    effectiveArray as isEffectiveArray,
    effectiveObject,
    effectiveObject as isEffectiveObject,
    effectiveString,
    effectiveString as isEffectiveString,
    effectiveUrl,
    isJSON,
    isIE,
    isUndefined
}
